import React, { useState } from 'react';
import { createPortal } from 'react-dom';

import RuleHistoryDialog from './history_dialog';

/*
 * PROD-7828 R14 P4 — "Rule: <name> v<no>, from <date>" under a pay or penalty line the rules engine
 * worked out (plan §5.5); it opens that rule's history with the line's version marked. Coded-engine and
 * Ops-added lines carry no rule, so nothing renders. props: rule_ref (logic.rule_ref_of(line)), on_error?.
 * The dialog is portaled to <body> so it never inherits the host cell's font size, tooltip or row hover.
 */
const RuleRefLink = ({ rule_ref, on_error }) => {
  const [open, setOpen] = useState(false);
  if (!rule_ref) return null;
  return (
    <>
      <button
        type="button"
        className="tp-link tp-rx-ref"
        title="Show this rule's history"
        onClick={() => setOpen(true)}
      >
        {rule_ref.text}
      </button>
      {open
        ? createPortal(
            <RuleHistoryDialog
              rule_key={rule_ref.rule_key}
              highlight_version_id={rule_ref.version_id}
              on_close={() => setOpen(false)}
              on_error={on_error}
            />,
            document.body
          )
        : null}
    </>
  );
};

export default RuleRefLink;
